import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  Status,
} from "../../../../features/admin/customization/appsetup/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = React.useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const country = useSelector((state) => state.customization.appsetup);

  const [name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = country?.current_page) => {
    await dispatch(
      GetAll({
        name,
      })
    );
  };

  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
      setModalMessage("Deleted Successfully");
      setModalShow(true);
      await fetch();
      return true;
    } catch (error) {
      setModalMessage("Delete Failed");
      setModalShow(true);
      console.error(error);
      return false;
    }
  };

  const toggleStatus = async (id) => {
    try {
      await dispatch(Status(id));
      await fetch();
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  return {
    country,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
    modalMessage,
    modalShow,
    setModalShow,
  };
};
